import moment from "moment";

const locale = window.navigator.userLanguage || window.navigator.language;
const countryCode = locale.split('-');
// const l = (locale === 'en-GB' || locale === 'en-gb') ? 'en-gb-better' : locale;

moment.updateLocale('en-gb', {
  longDateFormat: {
    LT : 'HH:mm',
    LL : 'D MMMM YYYY',
    L  : 'DD/MM/YYYY'
  }
});

export const YMDcountries = ['cn', 'hk', 'sg', 'tw', 'ja', 'ko', 'ca', 'hu', 'mn', 'lt'];

// D MMMM YYYY or MMMM D YYYY
export const longDate = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('LL');
}

// DD/MM/YYYY or MM/DD/YYYY
export const shortDate = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('L');
}

// Mon
export const weekDay = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return moment.weekdaysShort(localDate.day());
}

// Monday
export const longWeekDay = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return moment.weekdays(localDate.day());
}

// HH:mm
export const timeFormat = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('LT');
}

// YYYY-MM-DD
export const selectedDateFormat = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('YYYY-MM-DD');
}

// D
export const selectedDayFormat = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('D');
}

// MM
export const selectedM = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('M');
}

// MM
export const selectedMM = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('MM');
}

// D
export const selectedD = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('D');
}

// DD
export const selectedDD = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('DD');
}

// YYYY
export const selectedY = (date) => {
  const localDate = moment.utc(date).locale(locale);
  return localDate.format('YYYY');
}
